class AlsoAvailableIn extends HTMLElement {
  constructor(){
    super();

    // Provides access to StoreFront API. Scope: unauthenticated_read_product_listings
    this.token = 'cf0f2ee4770f4e1eb5068219636dbf00';
    this.endpoint = theme.routes.graphqlEndpoint;
    this.currentTitle = this.dataset.title;
    this.query = this.dataset.query;

  }

  connectedCallback() {
    this.init();
  }

  async init() {
    if (!this.currentTitle || !this.query) return;

    try {
      const res = await fetch(this.endpoint, {
        method: 'POST',
        headers: {
          'X-Shopify-Storefront-Access-Token': this.token,
          'Content-Type': 'application/graphql',
        },
        body: `{
          products(first: 250, query: "tag:${this.query}*") {
            edges {
              node {
                handle
                featuredImage {
                  src
                }
                title
              }
            }
          }
        }`
      });

      const data = await res.json();
      console.log({ res, data });

      if (res.ok) {
        this.data = data.data.products.edges;
        this.renderElements();
      }
    } catch (error) {
      console.log(error)
    }
  }

  renderElements() {
    const filtered = this.data.reduce((acc, obj) => {
      const { node: { title }} = obj;
      if (title === this.currentTitle) return acc;
      return [...acc, obj];
    }, []);
    if (!filtered.length) return;

    const container = document.createElement('div');
    container.innerHTML = `
      <p class="h4">Also Available In</p>
      <ul>
        ${
          filtered.map(({node: { title, handle, featuredImage}}) => {
            return `
              <li>
                <a href="/products/${handle}" title="${title}">
                  <div class="card__image" style="padding-top:100%">
                    <figure class="lazy-image product-item__image-figure lazy-image--animation lazy-image--background lazyloaded" data-ratio="1" style="padding-top: 100%" data-crop="false">
                      <img src="${featuredImage ? featuredImage.src : theme.settings.fallbackImage }&width=300" alt="${title}" loading="lazy">
                    </figure>
                  </div>
                  <div class="title">${title}</div>
                </a>
              </li>
            `
          }).join('')
        }
      </ul>
    `;

    this.append(container);
  }
}
if (!customElements.get('also-available-in')){
  customElements.define('also-available-in', AlsoAvailableIn);
}